<template>
  <div>
    <e-dialog
      dialog-title="订单明细"
      :center-dialog-visible="orderDetailsVisible"
      :show-sub-btn="false"
      popup-width="1000px"
      @resetPopupData="resetPopupData"
    >
      <tableList
        ref="tableRef"
        class="margin-t20"
        :loading="false"
        row-key="vocabularyId"
        :table-data="tableData"
        :table-label="tableLabel"
        max-height="500"
      >
        <template #showIndex="slotScope">
          <span>
            {{ (queryData.pageNum - 1) * queryData.pageSize + slotScope.scope.$index + 1 }}
          </span>
        </template>
        <template #productName="slot">
          <e-tooltip :content="slot.scope.row.productName" :set-length="10" />
        </template>
        <template #productSkuCode="slot">
          <e-tooltip :content="slot.scope.row.productSkuCode" :set-length="16" />
        </template>
      </tableList>
      <div class="pagination">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import tableList from '@/modules/projectA/components/common/e-table-list';
import api from '@/modules/projectA/api/order';
import eTooltip from '@/modules/projectA/components/common/e-tooltip';

export default {
  name: 'OrderDetailsDialog',
  components: {
    eDialog,
    tableList,
    eTooltip,
  },
  props: {
    orderDetailsVisible: Boolean,
    detailData: Object,
  },
  data() {
    return {
      queryData: {
        orderId: null,
        purchaseCompanyId: null,
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      tableData: [],
      tableLabel: [
        {
          label: '序号',
          slot: 'showIndex',
          align: 'center',
          width: '80px',
        },
        {
          label: '商品名称',
          param: 'productName',
          align: 'center',
          slot: 'productName',
        },
        {
          label: '商品编码',
          param: 'productSkuCode',
          align: 'center',
          slot: 'productSkuCode',
        },
        {
          label: '商品类别',
          param: 'lbmc',
          align: 'center',
        },
        {
          label: '类别编码',
          param: 'lbbm',
          align: 'center',
        },
        {
          label: '采购商名称',
          param: 'purchaseCompanyName',
          align: 'center',
          width: '100px',
        },
        {
          label: '供应商名称',
          param: 'supplierCompanyName',
          align: 'center',
          width: '100px',
        },
        {
          label: '品牌',
          param: 'brandName',
          align: 'center',
        },
        {
          label: '数量',
          param: 'quantity',
          align: 'center',
        },
        {
          label: '计量单位',
          param: 'goodsUnitName',
          align: 'center',
        },
        {
          label: '单价（含税）',
          param: 'price',
          align: 'center',
          width: '100px',
        },
        {
          label: '小计',
          param: 'subtotal',
          align: 'center',
          width: '100px',
        },
        {
          label: '运费',
          param: 'shippingCost',
          align: 'center',
        },
        {
          label: '物料编码',
          param: '',
          align: 'center',
        },
        {
          label: '框架协议编码',
          param: 'sinoProtocol',
          align: 'center',
          width: '100px',
        },
      ],
    };
  },
  mounted() {
    this.queryData.orderId = this.detailData.orderId;
    this.queryData.purchaseCompanyId = this.detailData.purchaseCompanyId;
    this.listSupplierSku();
  },
  methods: {
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.listSupplierSku();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.listSupplierSku();
    },
    resetPopupData() {
      this.$emit('closeDialog');
    },
    async listSupplierSku() {
      const res = await api.listSupplierSku(this.queryData);
      if (res.code === '200') {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
